export type CustomField =
  | SingleLineCustomField
  | SingleChoiceCustomField
  | MultiChoiceCustomField
  | BooleanCustomField
  | NumberCustomField
  | MoneyCustomField
  | DateCustomField
  | SingleUserCustomField
  | MultiUserCustomField;

export interface CustomFieldBase {
  id: number;
  name: string;
  type: CustomFieldType;
  createdAt: string;
  configuration: CustomFieldConfiguration;
  required: boolean;
}

export interface SingleLineCustomField extends CustomFieldBase {
  type: CustomFieldType.SingleLine;
  value: SingleLineFieldValue;
}

export interface SingleChoiceCustomField extends CustomFieldBase {
  type: CustomFieldType.SingleChoice;
  value: SingleChoiceFieldValue;
  configuration: { options: Array<{ id: number; value: string }> };
}

export interface MultiChoiceCustomField extends CustomFieldBase {
  type: CustomFieldType.MultiChoice;
  value: MultiChoiceFieldValue;
  configuration: { options: Array<{ id: number; value: string }> };
}

export interface BooleanCustomField extends CustomFieldBase {
  type: CustomFieldType.Boolean;
  value: BooleanFieldValue;
}

export interface NumberCustomField extends CustomFieldBase {
  type: CustomFieldType.Number;
  value: NumberFieldValue;
  configuration: { isRange: boolean };
}

export interface MoneyCustomField extends CustomFieldBase {
  type: CustomFieldType.Money;
  value: MoneyFieldValue;
  configuration: { isRange: boolean };
}

export type DateCustomField = CustomFieldBase & {
  type: CustomFieldType.Date;
  value: DateFieldValue;
};

export interface SingleUserCustomField extends CustomFieldBase {
  type: CustomFieldType.SingleUser;
  value: SingleUserFieldValue;
  configuration: { admins?: number[]; roles?: number[] };
}

export interface MultiUserCustomField extends CustomFieldBase {
  type: CustomFieldType.MultiUser;
  value: MultiUserFieldValue;
  configuration: { admins?: number[]; roles?: number[] };
}

export interface SingleLineFieldValue {
  value: string | null;
}

export interface SingleChoiceFieldValue {
  option: number | null;
}

export interface MultiChoiceFieldValue {
  options: number[];
}

export interface BooleanFieldValue {
  value: boolean;
}

export interface NumberFieldValue {
  value?: string;
  min?: string;
  max?: string;
}

export interface MoneyFieldValue {
  value?: string;
  min?: string;
  max?: string;
  currency: string | null;
}

export interface DateFieldValue {
  value: string | null;
}

export interface SingleUserFieldValue {
  admin: number | null;
}

export interface MultiUserFieldValue {
  admins: number[];
}

export enum CustomFieldType {
  SingleLine = 'single_line',
  SingleChoice = 'single_choice',
  MultiChoice = 'multi_choice',
  Boolean = 'boolean',
  Number = 'number',
  Money = 'money',
  Date = 'date',
  SingleUser = 'single_user',
  MultiUser = 'multi_user',
}

export type CustomFieldConfiguration = {
  options?: Array<{
    id: number;
    value: string;
  }>;
  isRange?: boolean;
  admins?: number[];
  roles?: number[];
};
